import { isBefore, endOfMonth, startOfTomorrow } from "date-fns";
export var MAX_YEARS = 6; /*
                          * CC expiry dates go off last day of month
                          */
var getExpirationDate = function getExpirationDate(value) {
  var month = Number(value.slice(0, 2));
  var year = Number(value.slice(2, 6));
  var expirationDate = endOfMonth(new Date(year, month - 1));
  return expirationDate;
};
var validMedicareExpiryFormat = function validMedicareExpiryFormat(value) {
  var month = Number(value.slice(0, 2));
  if (month > 12 || month < 1) {
    return false;
  }
  return /^\d{2}\d{4}$/.test(value);
}; /* 
   Check if Expiry date is in the future.
   */
var isExpired = function isExpired(value) {
  var expirationDate = getExpirationDate(value);
  return isBefore(expirationDate, startOfTomorrow());
};
var validDateRange = function validDateRange(value, maxYears) {
  var expirationDate = getExpirationDate(value || "");
  var maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + maxYears);
  return isBefore(expirationDate, maxDate);
};
var validMedicareExpiry = function validMedicareExpiry(value) {
  var maxYears = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_YEARS;
  if (!value) {
    return "Please enter your Medicare card expiry date.";
  }
  var numbersOnly = value.replace(/[/]/g, "");
  if (!validMedicareExpiryFormat(numbersOnly) || !validDateRange(numbersOnly, maxYears)) {
    return "This doesn't look right. Please enter your Medicare expiry date written as MM/YYYY.";
  } else if (isExpired(numbersOnly)) {
    return "It looks like your Medicare card has expired. Please check the expiry date and enter it as it appears on your card.";
  }
  return;
};
export default validMedicareExpiry;